<template>
    <div>
        <div class="limiter">
            <div class="container-login100">
                <div>
                    <div class="wrap-login100">
                        <form class="login100-form validate-form" v-if="!isSignup" autocomplete="off">
                            <span class="login100-form-title p-b-26">
                                <img :src="require('@/assets/images/login-logo_simple.png')"
                                    style="width:205px; height:87px;" />
                            </span>
                            <span class="login100-form-title p-b-48">
                                <i class="zmdi zmdi-font"></i>
                            </span>

                            <div class="wrap-input100 validate-input" data-validate="Valid email is: a@b.c">
                                <input class="input100" type="text" v-model="usrId" placeholder="아이디를 입력하세요"
                                    style="padding-left:20px;" autocomplete="off" readonly
                                    onfocus="this.removeAttribute('readonly');">
                                <span class="focus-input100"></span>
                            </div>

                            <div class="wrap-input100 validate-input" data-validate="Enter password">
                                <span class="btn-show-pass">
                                    <i class="zmdi zmdi-eye"></i>
                                </span>
                                <input class="input100" type="password" v-model="pwd" placeholder="비밀번호를 입력하세요"
                                    style="padding-left:20px;" @keydown.enter.prevent="loginAction"
                                    autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly');">
                                <span class="focus-input100"></span>
                            </div>

                            <div class="container-login100-form-btn">
                                <div class="wrap-login100-form-btn">
                                    <div class="login100-form-bgbtn"></div>
                                    <img :src="require('@/assets/images/login-form-button.png')"
                                        style="width:400.4px; cursor:pointer;" @click="loginAction()" />
                                </div>
                            </div>

                            <hr style="margin-top:41px; margin-bottom:28px;" />

                            <div class="container-login100-form-btn" style="margin-bottom:80px;">
                                <div class="wrap-login100-form-btn">
                                    <div class="login100-form-bgbtn"></div>
                                    <img :src="require('@/assets/images/new-user-button.png')"
                                        style="width:400.4px; cursor:pointer;" @click="isSignup = true" />
                                </div>
                            </div>
                        </form>

                        <!-- 회원가입 폼 -->
                        <form class="login100-form validate-form" v-else @submit.prevent="signupAction"
                            autocomplete="off">
                            <span class="login100-form-title p-b-26">
                                회원가입
                            </span>

                            <div class="wrap-input100 validate-input" style="margin-bottom: 5px;">
                                <input class="input100" type="text" v-model="signupId" placeholder="아이디"
                                    style="padding-left:20px;" autocomplete="off" readonly
                                    onfocus="this.removeAttribute('readonly');">
                                <span class="focus-input100"></span>
                            </div>
                            <p
                                style="font-size: 12px; color: #888; text-align: left; padding-left: 5px; margin-bottom: 15px;">
                                * 아이디는 영문 또는 영문자+숫자 조합으로 5자이상
                            </p>

                            <div class="wrap-input100 validate-input">
                                <input class="input100" type="text" v-model="signupNm" placeholder="별명"
                                    style="padding-left:20px;" autocomplete="off" readonly
                                    onfocus="this.removeAttribute('readonly');">
                                <span class="focus-input100"></span>
                            </div>

                            <div class="wrap-input100 validate-input" style="margin-bottom: 5px;">
                                <input class="input100" type="password" v-model="signupPwd" placeholder="비밀번호"
                                    style="padding-left:20px;" autocomplete="new-password" readonly
                                    onfocus="this.removeAttribute('readonly');">
                                <span class="focus-input100"></span>
                            </div>
                            <p
                                style="font-size: 12px; color: #888; text-align: left; padding-left: 5px; margin-bottom: 15px;">
                                * 비밀번호는 영문자,숫자,특수문자 반드시 포함한 8자리이상
                            </p>

                            <div class="wrap-input100 validate-input">
                                <input class="input100" type="password" v-model="signupPwdConfirm" placeholder="비밀번호 확인"
                                    style="padding-left:20px;" autocomplete="new-password" readonly
                                    onfocus="this.removeAttribute('readonly');">
                                <span class="focus-input100"></span>
                            </div>

                            <div class="container-login100-form-btn">
                                <div class="wrap-login100-form-btn">
                                    <div class="login100-form-bgbtn"></div>
                                    <button class="login100-form-btn" type="submit">
                                        가입하기
                                    </button>
                                </div>
                            </div>

                            <div class="text-center p-t-20">
                                <a class="txt2" href="#" @click.prevent="isSignup = false">
                                    로그인 화면으로 돌아가기
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <footer></footer>

    </div>
</template>

<script setup>

import { ref, getCurrentInstance } from 'vue'
import axios from '../plugins/axios'

const { proxy } = getCurrentInstance();

const usrId = ref("");
const pwd = ref("");

const isSignup = ref(false);
const signupId = ref("");
const signupNm = ref("");
const signupPwd = ref("");
const signupPwdConfirm = ref("");

const loginAction = () => {

    proxy.$store.commit("commStore/clearServerCallCount");

    axios.post('/auth/login', { usrId: usrId.value, pwd: pwd.value }).then(function (response) {

        const result = response.data;
        console.log(response.data)
        if (result.status === 'success') {

            localStorage.setItem("draco-user-id", usrId.value);

            localStorage.setItem("draco-user-name", result.data.userNm);

            localStorage.setItem("draco-authrt-id", result.data.authrtId);

            proxy.$store.commit("commStore/setIsFotterShow", false);

            proxy.$router.push("/main");
        } else {
            alert("가입하지 않은 아이디 또는 잘못된 비밀번호 입니다. ");
        }
    }).catch(function (error) {
        alert(error);
    })
}

const signupAction = () => {
    if (!signupId.value || !signupNm.value || !signupPwd.value || !signupPwdConfirm.value) {
        alert("모든 정보를 입력해주세요.");
        return;
    }

    if (signupPwd.value !== signupPwdConfirm.value) {
        alert("비밀번호가 일치하지 않습니다.");
        return;
    }

    axios.post('/auth/signup', {
        userId: signupId.value,
        userNm: signupNm.value,
        pswd: signupPwd.value
    }).then(function (response) {
        const result = response.data;
        if (result.status === 'success') {
            alert(result.message);
            isSignup.value = false;
            usrId.value = signupId.value; // 가입한 아이디 채워주기
        } else {
            alert(result.message);
        }
    }).catch(function (error) {
        alert(error);
    });
}
</script>

<style src="../../public/css/login.css" scoped></style>